

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ImageSwiper.css";
import Slider1 from '../images/slider1.jpeg';
import Slider2 from '../images/slider2.jpeg';
import Slider3 from '../images/slider3.jpeg';
import Slider4 from '../images/slider4.jpeg';
import Slider5 from '../images/slider5.jpeg';
import Slider6 from '../images/slider6.jpeg';
import Slider7 from '../images/slider7.jpeg';
import Slider8 from '../images/slider8.jpeg';







SwiperCore.use([Navigation, Pagination, Autoplay]);

const ImageSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next text-green-500" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper1 p-8"
        >
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider1}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider2}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider3}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider4}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider5}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider6}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider7}
                    alt=""
                />
            </SwiperSlide>
            <SwiperSlide>
                <img
                    className="w-[500px]"
                    src={Slider8}
                    alt=""
                />
            </SwiperSlide>
  




            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>


    );
};

export default ImageSwiper;
